module.exports = __webpack_public_path__ + "img/typeAction2.dabdfac2.jpg";